import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from '@angular/forms';
import { EventMessage } from '@azure/msal-browser';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { SingleEmailValidator } from 'src/app/directives/multi-email.directive';
import {
  validarRut,
  VerificacionRutValidator,
} from 'src/app/directives/verifica-rut.directive';
import { Cesionario } from 'src/app/models/Cesion/Cesionario';
import { ReceptorRequest } from 'src/app/models/Receptor/ReceptorRequest';
import { CesionarioService } from 'src/app/services/cesionario.service';
import { PermissionService } from 'src/app/services/permission.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { RutHelper } from 'src/app/helpers/rut.helper';

@Component({
  selector: 'app-cesionario-entry',
  templateUrl: './cesionario-entry.component.html',
  styleUrls: ['./cesionario-entry.component.scss'],
})
export class CesionarioEntryComponent implements OnInit {
  //@ViewChild("cesionarioFormRef") private childFormRef: NgForm;
  public cesionarioForm: FormGroup;
  private cesionarioObj: Cesionario = new Cesionario();
  private emisorId: string = this.tokenStorage.getCompany();
  @Input() public cesionarioToEdit: Cesionario = undefined;
  @Input() public editMode: boolean = null;
  @Input() public detailMode: boolean = false;
  @Output() private sendCloseRequestEmitter: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() private sendCesionarioRequest: EventEmitter<any> =
    new EventEmitter<any>();
  constructor(
    private formBuilder: FormBuilder,
    private tokenStorage: TokenStorageService,
    public permissions: PermissionService
  ) {}

  ngOnInit(): void {
    this.createForm();
    if (this.editMode) {
      this.setcesionarioDataToForm(this.cesionarioToEdit);
    }
  }

  createForm() {
    this.cesionarioForm = this.formBuilder.group({
      rutString: ['', [Validators.required, VerificacionRutValidator]],
      razonSocial: ['', Validators.required],
      direccion: ['', Validators.required],
      nombreContacto: ['', Validators.required],
      telefono: [
        0,
        [
          Validators.required,
          Validators.min(100000000),
          Validators.max(999999999),
        ],
      ],
      correo: ['', [Validators.required, SingleEmailValidator]],
    });
  }
  onSubmit() {
    if (this.cesionarioForm.valid) {
      this.getFormData();
      this.sendCesionarioRequest.emit(this.cesionarioObj);
    }
  }
  sendCloseRequest() {
    this.sendCloseRequestEmitter.emit();
  }

  getFormData() {
    var rut = this.cesionarioForm.controls.rutString.value;
    const { rut: rutNumber, dv } = RutHelper.parse(rut);
    this.cesionarioObj.rut = rutNumber;
    this.cesionarioObj.dv = dv;
    this.cesionarioObj.razonSocial =
      this.cesionarioForm.controls.razonSocial.value;
    this.cesionarioObj.direccion = this.cesionarioForm.controls.direccion.value;
    this.cesionarioObj.fono = this.cesionarioForm.controls.telefono.value;
    this.cesionarioObj.nombreContacto =
      this.cesionarioForm.controls.nombreContacto.value;
    this.cesionarioObj.correo = this.cesionarioForm.controls.correo.value;
    this.cesionarioObj.emisorId = this.emisorId;
    if (this.editMode)
      this.cesionarioObj.cesionarioId = this.cesionarioToEdit.cesionarioId;
  }

  setcesionarioDataToForm(receivedcesionario: Cesionario) {
    this.cesionarioForm.patchValue(receivedcesionario);
    this.cesionarioForm
      .get('rutString')
      .patchValue(receivedcesionario.rutFormateado);
    this.cesionarioForm.get('telefono').patchValue(receivedcesionario.fono);
    this.cesionarioForm
      .get('direccion')
      .patchValue(receivedcesionario.direccion);
    this.cesionarioForm.get('correo').patchValue(receivedcesionario.correo);
    this.cesionarioForm
      .get('nombreContacto')
      .patchValue(receivedcesionario.nombreContacto);
    this.cesionarioForm
      .get('razonSocial')
      .patchValue(receivedcesionario.razonSocial);
  }
}
